import _ from "lodash";
import { axiosInstance } from "./globals";
import jwtDecode from "jwt-decode";
import Cookies from "js-cookie";

import { AdminFilter, SaleAccountFilter } from "@/model/filters";
import { DataSourceRequest } from "@/model/DataSourceRequest";
import { DataSourceResult } from "@/model/DataSourceResult";
import * as util from "@/service/util";
import { DateTime } from "luxon";
import axios from "axios";
import environment from "@/environment";
import { enumLoginType } from "@/views/enums/loginType";

const isHttps = location.protocol === 'https:';
const COOKIE_OPTIONS: Cookies.CookieAttributes = {
  path: '/',
  secure: isHttps,
  sameSite: isHttps ? 'None' : 'Lax'
};

export function isSignedIn(): boolean {
  return !!getToken();
}

export function getToken(): string {
  const token = Cookies.get("token") || localStorage.getItem("token");
  if (!token) return undefined;

  try {
    const { exp } = jwtDecode(token) as any;
    if (DateTime.now().toUnixInteger() < exp) {
      return token;
    }
  } catch (e) {
    // Token không đúng định dạng hoặc lỗi giải mã
  }

  // Token hết hạn hoặc không hợp lệ: xóa dữ liệu local và redirect về login
  // KHÔNG gọi signOut() để tránh vòng đệ quy (signOut → getAuthHeaders → getToken → signOut)
  _clearAuthData();
  window.location.href = environment.appBaseUrl;
}

export function getAuthHeaders() {
  return {
    Authorization: "Bearer " + getToken()
  };
}

export function getCurrentUser() {
  if (isSignedIn()) {
    try {
      return JSON.parse(Cookies.get("user") || localStorage.getItem("user"));

    } catch (e) { }
  }
}

export function getCurrentUserId() {
  if (isSignedIn()) {
    return +(Cookies.get("userId") || localStorage.getItem("userId")) || undefined;
  }
}


export function getTokenExpTime(): number {
  if (isSignedIn()) {
    return +(Cookies.get("tokenExpire") || localStorage.getItem("tokenExpire")) || undefined;
  }
}

export async function testAccount(username: string, password: string) {
  const user = (await axiosInstance.post("/Users/authenticate", { username, password })).data;
  return user;
}
export async function SigninGoogle(data) {
  return (await axiosInstance.post("/Users/SigninGoogle", data, { headers: getAuthHeaders() })).data;
}
export async function signIn(username: string, password: string, rememberMe = false) {
  const user = (await axiosInstance.post("/Users/authenticate", { username, password })).data;
  const decodedJwt = jwtDecode(user.token) as any;

  if (rememberMe) {
    localStorage.setItem("userId", user.id.toString());
    localStorage.setItem("token", user.token);
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("tokenExpire", decodedJwt.exp.toString());

  } else {
    Cookies.set("userId", user.id.toString(), COOKIE_OPTIONS);
    Cookies.set("token", user.token, COOKIE_OPTIONS);
    Cookies.set("user", JSON.stringify(user), COOKIE_OPTIONS);
    Cookies.set("tokenExpire", decodedJwt.exp.toString(), COOKIE_OPTIONS);
  }

  return user;
}


export async function signInVnptSso(service: string, ticket: string) {
  const params = { service, ticket };
  const user = (await axiosInstance.post("/Users/SigninCas", null, { params })).data;
  if (user.code == 'signinCas_userNotRegistered') {
    return user;
  }
  const decodedJwt = jwtDecode(user.token) as any;

  localStorage.setItem("userId", user.id);
  localStorage.setItem("token", user.token);
  localStorage.setItem("user", JSON.stringify(user));
  localStorage.setItem("tokenExpire", decodedJwt.exp);

  localStorage.setItem("signInBySSO", enumLoginType.VNPT);

  return user;
}

export async function signInSME(code: string) {
  const params = { code };
  const data = (await axiosInstance.get("/oneSme/authenticate", { params })).data.data;

  const decodedJwt = jwtDecode(data.token) as any;

  Cookies.set("IDPAccessToken", data.oneSmeAccessToken, COOKIE_OPTIONS);
  Cookies.set("userId", data.id.toString(), COOKIE_OPTIONS);
  Cookies.set("token", data.token, COOKIE_OPTIONS);
  Cookies.set("user", JSON.stringify(data), COOKIE_OPTIONS);
  Cookies.set("tokenExpire", decodedJwt.exp.toString(), COOKIE_OPTIONS);
  return data;
}

/**
 * Xóa toàn bộ dữ liệu xác thực khỏi cookie và localStorage.
 * Dùng nội bộ để tránh đệ quy khi token hết hạn.
 */
function _clearAuthData() {
  const keys = ["userId", "token", "user", "tokenExpire", "IDPAccessToken"];

  // 1. Xóa Cookie với tùy chuẩn hiện tại
  keys.forEach(key => Cookies.remove(key, COOKIE_OPTIONS));

  // 2. Fallback: Xóa Cookie theo kiểu cũ (phòng trường hợp trình duyệt vẫn còn lưu)
  keys.forEach(key => {
    Cookies.remove(key); // Default removal
    Cookies.remove(key, { secure: true, sameSite: 'None', path: '/' });
  });

  // 3. Xóa LocalStorage
  keys.forEach(key => localStorage.removeItem(key));
  localStorage.removeItem("signInBySSO");
  localStorage.removeItem("vnptSsoService");
}
export function isSsoLogin(): boolean {
  const loginType = localStorage.getItem("signInBySSO");
  const isSsoType = loginType === enumLoginType.VNPT || loginType === enumLoginType.GOOGLE;
  return isSsoType || !!Cookies.get("IDPAccessToken");
}

export async function signOut() {
  // Chỉ gọi API Logout khi token còn hợp lệ để tránh đệ quy:
  // signOut → getAuthHeaders → getToken (token hết hạn) → signOut
  const token = Cookies.get("token") || localStorage.getItem("token");
  if (token) {
    try {
      const { exp } = jwtDecode(token) as any;
      if (DateTime.now().toUnixInteger() < exp) {
        await axiosInstance.post("/Users/Logout", null, { headers: { Authorization: "Bearer " + token } });
      }
    } catch (error) {
      // Bỏ qua lỗi khi gọi logout API
    }
  }
  const signInBySSO = localStorage.getItem("signInBySSO");
  const ssoService = localStorage.getItem("vnptSsoService");
  localStorage.removeItem("signInBySSO");
  localStorage.removeItem("vnptSsoService");
  _clearAuthData();
  if (signInBySSO == enumLoginType.VNPT) {
    const logoutUrl = `https://id.vnpt.com.vn/cas/logout?service=${ssoService}`;
    window.location.replace(logoutUrl);
    return;
  }
  window.location.href = environment.appBaseUrl;
}


export async function getUser(id: number | string) {
  return (await axiosInstance.get("/Users/" + id, { headers: getAuthHeaders() })).data;
}


export async function reFetchCurrentUser() {
  const userId = getCurrentUserId();
  const user = await getUser(userId);

  if (localStorage.getItem("user")) {
    localStorage.setItem("user", JSON.stringify(user));
  } else if (Cookies.get("user")) {
    Cookies.set("user", JSON.stringify(user), COOKIE_OPTIONS);
  }

  return user;
}


export async function getAdmins(filter: AdminFilter): Promise<any> {
  // Honestly will we even reach 500 admins? That's kinda insane and I'm lazy enough to do this
  const body: DataSourceRequest = {
    page: 1,
    pageSize: 500,
    sorts: [
      { field: "CreatedAt", dir: "desc" }
    ]
  };

  if (filter.q) {
    body.filters = [
      { field: "name", operator: "contains", value: filter.q, logic: "or" },
      { field: "email", operator: "contains", value: filter.q, logic: "or" },
      { field: "phone", operator: "contains", value: filter.q, logic: "or" },
      { field: "username", operator: "contains", value: filter.q, logic: "or", filters: [] },
    ];
  }

  return (await axiosInstance.post("/Users/GetAllAdmin", body, { headers: getAuthHeaders() })).data?.data;
}


export async function createAdmin(data) {
  return (await axiosInstance.post("/Users/CreateAdmin", data, { headers: getAuthHeaders() })).data;
}


export async function createSaleAccount(data) {
  return (await axiosInstance.post("/Users/CreateManager", data, { headers: getAuthHeaders() })).data;
}
// export async function CreateCustomerAndUser(data) {
//   const headers = getAuthHeaders();
//   return (await axiosInstance.post("/Users/CreateCustomerAndUser", data, { headers })).data;
// }
export async function CreateCustomerAndUser(data, config = {}) {
  const headers = getAuthHeaders();
  return (await axiosInstance.post("/Users/CreateCustomerAndUser", data, { headers, ...config })).data;
}


export async function getSaleAccounts(filter: SaleAccountFilter): Promise<DataSourceResult<any>> {
  const body: DataSourceRequest = {
    page: filter.page,
    pageSize: filter.pageSize,
    filters: [],
    sorts: [
      { field: "CreatedAt", dir: "desc" }
    ]
  };

  const filterCount = util.countPredicate([
    filter.q, filter.areaId
  ]);

  if (filter.q && filterCount === 1) {
    body.filters = [
      { field: "name", operator: "contains", value: filter.q, logic: "or", filters: [] },
      { field: "email", operator: "contains", value: filter.q, logic: "or", filters: [] },
      { field: "phone", operator: "contains", value: filter.q, logic: "or", filters: [] },
      { field: "username", operator: "contains", value: filter.q, logic: "or", filters: [] },
    ];

  } else {
    if (filter.areaId) {
      body.filters.push({ field: "saleAreaId", operator: "eq", value: filter.areaId, logic: "and" });
    }

    if (filter.q) {
      body.filters[0].filters = [
        { field: "name", operator: "contains", value: filter.q, logic: "or" },
        { field: "email", operator: "contains", value: filter.q, logic: "or" },
        { field: "phone", operator: "contains", value: filter.q, logic: "or" },
        { field: "username", operator: "contains", value: filter.q, logic: "or", filters: [] },
      ];
    }
  }

  return (await axiosInstance.post<DataSourceResult<any>>("/Users/GetAllManager", body, { headers: getAuthHeaders() })).data;
}


export async function getCustomerAdminAccounts(filter: SaleAccountFilter): Promise<any> {
  const body: DataSourceRequest = {
    page: filter.page,
    pageSize: filter.pageSize,
    filters: [],
    sorts: [
      { field: "id", dir: "desc" }
    ]
  };

  const filterCount = util.countPredicate([
    filter.q, filter.areaId
  ]);

  if (filter.q && filterCount === 1) {
    body.filters = [
      { field: "name", operator: "contains", value: filter.q, logic: "or", filters: [] },
      { field: "customerName", operator: "contains", value: filter.q, logic: "or", filters: [] },
      { field: "username", operator: "contains", value: filter.q, logic: "or", filters: [] },
      { field: "email", operator: "contains", value: filter.q, logic: "or", filters: [] },
      { field: "phone", operator: "contains", value: filter.q, logic: "or", filters: [] },
    ];

  } else {
    if (filter.areaId) {
      body.filters.push({ field: "saleAreaId", operator: "eq", value: filter.areaId, logic: "and" });
    }

    if (filter.q) {
      body.filters[0].filters = [
        { field: "name", operator: "contains", value: filter.q, logic: "or" },
        { field: "email", operator: "contains", value: filter.q, logic: "or" },
        { field: "phone", operator: "contains", value: filter.q, logic: "or" },
        { field: "username", operator: "contains", value: filter.q, logic: "or", filters: [] },
      ];
    }
  }

  return (await axiosInstance.post<DataSourceResult<any>>("/Users/GetAllCustomer", body, { headers: getAuthHeaders() })).data;
}


export async function updateUser(data) {
  return (await axiosInstance.post("/Users/Update", data, { headers: getAuthHeaders() })).data;
}


export async function deleteUser(id: number) {
  return (await axiosInstance.post("/Users/DeleteUser", null, {
    headers: getAuthHeaders(),
    params: { id }
  })).data;
}

export async function unlockAccount(id: number) {
  return (await axiosInstance.post("/Users/CancelLocked", null, {
    headers: getAuthHeaders(),
    params: { id }
  })).data;
}

export async function unlockAccountCustomer(customerId: number, reason: string) {
  const body = { customerId, reason };
  return (await axiosInstance.post("/UserConsent/UnlockCustomerAccounts", body, {
    headers: getAuthHeaders(),
  })).data;
}


export async function resetPassword(id: number, password: string) {
  return (await axiosInstance.post("/Users/ResetPassword", { id, password }, {
    headers: getAuthHeaders()
  })).data;
}


export async function changeMyPassword(oldPassword: string, newPassword: string) {
  return (await axiosInstance.post("/Users/ChangeMyPassword", { oldPassword, newPassword }, {
    headers: getAuthHeaders()
  })).data;
}


export async function getCustomerAdmins(customerId: number): Promise<any[]> {
  const body = { page: 1, pageSize: 500 };

  return (await axiosInstance.post<DataSourceResult<any>>(`/Users/GetAllCustomerAdmin/${customerId}`, body, {
    headers: getAuthHeaders()
  })).data.data;
}


export async function createCustomerAdmin(data) {
  const { customerId } = data;
  return (await axiosInstance.post(`/Users/CreateCustomerAdmin/${customerId}`, data, { headers: getAuthHeaders() })).data;
}


export async function getCustomerUsers(filter: AdminFilter): Promise<DataSourceResult<any>> {
  const body: DataSourceRequest = {
    page: filter.page,
    pageSize: filter.pageSize,
  };

  if (filter.q) {
    body.filters = [
      { field: "name", operator: "contains", value: filter.q, logic: "or" },
      { field: "email", operator: "contains", value: filter.q, logic: "or" },
      { field: "phone", operator: "contains", value: filter.q, logic: "or" },
    ];
  }

  return (await axiosInstance.post<DataSourceResult<any>>(`/Users/GetAllCustomerUser`, body, {
    headers: getAuthHeaders()
  })).data;
}


export async function createCustomerUser(data) {
  return (await axiosInstance.post(`/Users/CreateCustomerUser`, data, { headers: getAuthHeaders() })).data;
}

export async function forgetPassword(email: string) {
  return (await axiosInstance.post("/Users/ForgotPassword", { email })).data;
}

export async function userResetPassword(password: string, params: { secretKey: string }) {
  return (await axiosInstance.post("/Users/UserResetPassword", { password }, { params })).data;
}

export async function verifyEmail(email: string, isSecretKeyValid: boolean, secretKey: string) {
  const recaptchaToken = await util.grecaptchaExecute();
  if (isSecretKeyValid) {
    return (await axiosInstance.post("/Users/VerifyEmail", { email, recaptchaToken }, {
      params: {
        secretKey: secretKey
      }
    })).data;
  }
  else {
    return (await axiosInstance.post("/Users/VerifyEmail", { email, recaptchaToken })).data;
  }
}

export async function verifyActivationCode(secretKey: string) {
  return (await axiosInstance.get("/Users/VerifyActivationCode", { params: { secretKey } })).data;
}

export async function activateAccount(data: any) {
  return (await axiosInstance.post("/Users/ActivationAccount", data, {
    params: {
      secretKey: data.secretKey
    }
  })).data;
}

export async function uploadUsersExcelFile(file: File) {
  const headers = getAuthHeaders();
  const formData = new FormData();
  formData.append("formFile", file);

  try {
    await axiosInstance.post("/Users/Import", formData, { headers });
    return true;
  } catch (err) {
    throw err;
  }
}


export async function getAllUserForExport() {
  const headers = getAuthHeaders();
  return (await axiosInstance.get("/Users/GetAllCustomerUser", { headers })).data;
}

export async function deleteAllViewer() {
  const headers = getAuthHeaders();
  return (await axiosInstance.post("/Users/DeleteAllCustomerUserView", null, { headers })).data;
}
export async function getProfileById(userId: number | string) {
  //return (await axiosInstance.get(`/Users/${userId}`)).data;
  return (await axiosInstance.get(`/Users/${userId}`, { headers: getAuthHeaders() })).data;
}

/**
 * 
 * @param userId 
 * @returns 
 */
export async function getUserDetail() {
  if (!isSignedIn()) {
    return null;
  }
  try {
    const userId = getCurrentUserId();
    const user = (await axiosInstance.get(`/Users/${userId}`, { headers: getAuthHeaders() })).data;
    const userStrJson = JSON.stringify(user);
    Cookies.set("user", userStrJson, COOKIE_OPTIONS);
    localStorage.setItem("user", userStrJson);
    return user;
  } catch (error) {
    return null;
  }
}

export interface User {
  id: number;
  name: string;
  username: string; 
  email: string;
  phone: string;
  address: string;
  role: string;
  token: string | null;
  saleAreaId: number;
  customerId: number;
  mustChangePassword: boolean;
  changePasswordMessage: string | null;
  activeFaceId: number;
  activeVoiceText: number;
  apiToken: string | null;
  oneSmeAccessToken: string | null;
  photoUrl: string | null;
  province: string | null;
}
